export function isFacets(url: string) {
  if (url) {
    const hasFacets = url?.indexOf('facets=')

    return hasFacets !== -1
  }

  return false
}
